import { Link } from 'react-router-dom';
import { PATHS } from '@shared/router/paths';

/** System 404 route. Not a feature page — part of the routing shell. */
export function NotFoundRoute() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <p className="text-sm font-medium uppercase tracking-widest text-primary">404</p>
      <h1 className="text-2xl font-semibold text-foreground">Page not found</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        The page you are looking for doesn’t exist or has been moved.
      </p>
      <Link
        to={PATHS.root}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
      >
        Return home
      </Link>
    </div>
  );
}
